import React from 'react'
import OrgUsersDisplay from '../popups/OrgUsersDisplay';
import { OrgAssociationType, Securables } from '../Enums';
import OnlyForRole from '../components/OnlyForRole';


const ConsultantPage = () => {

    return <OnlyForRole role={Securables.organization_consultant}><OrgUsersDisplay assocationType={OrgAssociationType.Consultant} /></OnlyForRole>;
}


export default ConsultantPage;